import { Button, DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRapidAlertFeed extends Layout {
    buttonNoNotificaiton: Button;
    buttonNotification: Button;
    labelNotificationNumber: Label;
    panelRapidAlert: Panel;
    sourceRapidAlert: DataSource;
}
